export class UrlParamsModel {
    public Agent:string;

    public UUID:string;

    public Source:string;

    public Lang:string;

    public Token:string;

    public State:string;

    constructor(agent:string, uuid:string, source:string, lang:string, token:string, state:string){
        this.Agent = agent;
        this.UUID = uuid;
        this.Source = source;
        this.Lang = lang;
        this.Token = token;
        this.State = state;
    }
}
